<div class="command-action-icon">
  @for (command of allowedCommands; track command) {
    @if (!command.active || !command.onActiveCommand) {
      @if (command.visible) {
        <a
          [ngClass]="command.className || 'command-action'"
          (click)="applyCommand(command, command.icon)"
          >
          @if (command.icon) {
            <mat-icon
              class="link-icon"
              (click)="add()"
              [matTooltip]="command.toolTip | translate"
              [svgIcon]="command.icon"
            ></mat-icon>
          }
          <span [matTooltip]="command.toolTip | translate" class="commands-links" (click)="add()">
            {{ command.title | translate| uppercase }}
          </span>
        </a>
      }
      @if (command.warningIcon) {
        <mat-icon
          class="warning-icon"
          [matTooltip]="command.toolTip | translate"
          [svgIcon]="command.warningIcon"
        ></mat-icon>
      }
    } @else {
      @if (command.visible) {
        <a
          [ngClass]="command.className || 'command-action'"
          (click)="applyActiveCommand(command)"
          >
          @let activeIcon = command.activeIcon ?? command.icon;
          @if (activeIcon) {
            <mat-icon class="link-icon" [svgIcon]="activeIcon"></mat-icon>
          }
          {{ command.activeTitle | translate | uppercase}}
        </a>
      }
    }
  }
</div>
